
/**
 * Crée un DOM element a partir d'un array d'object
 * @param {object} data
 */
export function createAllBlock(data){

    let html = '';
    $.each(data, function(index, object){

        // verifie le type de chaque element et crée le block html correspondant
        if(object.type === 'twitter'){
            html += createtwitterBlock(object);
        }

        if(object.type === 'facebook'){
            html += createFacebookBlock(object);
        }

        if(object.type === 'instagram'){
            html += createInstagramBlock(object);
        }

    });

    return $(html);
}

/** Crée le block facebook */
function createFacebookBlock(post)
{
    let html =  `<div class="contentGrid-item facebook">
                    <div class="murSocial-facebook">
                        ${post.thumbnail ?
                            `<figure class="murSocial-facebook-image" style="background-image: url('${post.thumbnail}');"></figure>` : ''
                        }
                        <a class="murSocial-facebook-header" href="${post.url}" class="actuFacebook" target="_blank">
                            <h6 class="titre6--lowercase">Markal</h6>
                            <small class="tip">${post.date}</small>
                        </a>
                        <div class="murSocial-facebook-contenu">
                            <p>${post.description}</p>
                        </div>
                    </div>
                </div>`
    return html;
}

/** Crée le block Instagram */
/**
 * <pre>${post.text.slice(0, 450)}</pre>
 */
function createInstagramBlock(post)
{
    let html = `<div class="contentGrid-item instagram">
                <div class="murSocial-instagram">
                    ${post.img ?
                        `<figure class="murSocial-instagram-image" style="background-image: url('${post.img}');"></figure>` : ''
                    }
                    <a target="_blank" class="murSocial-instagram-header" href="${post.url}">
                        <h6 class="titre6--lowercase">Markal</h6>
                        <small class="tip">${post.date}</small>
                    </a>
                    <div class="murSocial-instagram-contenu">
                        <p>${post.text.slice(0, 450)}</p>
                    </div>
                </div>
            </div>`
    return html;
}

/** Crée le block de Twitter */
function createtwitterBlock(post)
{
    let html = `<div class="contentGrid-item twitter">
                    <div class="murSocial-twitter">
                        ${post.img ?
                            `<figure class="murSocial-twitter-image" style="background-image: url('${post.img}');"></figure>` : ''
                        }
                        <a target="_blank" class="murSocial-twitter-header" href="${post.url}">
                            <h6 class="titre6--lowercase">@${post.screenName}</h6>
                            <small class="tip">${post.date}</small>
                        </a>
                        <div class="murSocial-twitter-contenu">
                            <p>${post.message}</p>
                        </div>
                    </div>
                </div>`
    return html;
}


export function createFacebookHomeBlock(post)
{
    let html =  `<div class="col-sm-7">
                    <div class="homeRS-facebook">
                        ${post.thumbnail ?
                            `<figure class="homeRS-facebook-image" style="background-image: url('${post.thumbnail}');"></figure>` : ''
                        }
                        <a class="homeRS-facebook-header" href="${post.url}" target="_blank">
                            <h6 class="titre6--lowercase">Markal</h6>
                            <small class="tip">${post.date}</small>
                        </a>
                        <div class="homeRS-facebook-contenu">
                            <p>${post.description}</p>
                        </div>
                    </div>
                </div>`;
    return html;
}

export function createInstagramHomeBlock(post)
{
    let html = `<div class="col-sm-5">
                    ${post[0] ? ` <a href="${post[0].url}" target="_blank" class="homeRS-instagram" style="background-image: url('${post[0].img}');"></a>` : ''}
                    ${post[1] ? ` <a href="${post[1].url}" target="_blank" class="homeRS-instagram" style="background-image: url('${post[1].img}');"></a>` : ''}
            </div>`
    return html;
}

/** Masque le loader du DOM */
export function switchLoading()
{
    $("#chargement").removeClass('active');
}

/**
 * @param string text
 * @return string
 */
export function erreurBlock(text)
{
    return `<div class="alert alert-warning" role="alert">
                ${text}
            </div>`
}

/**
 * @param string text
 * @return string
 */
export function erreurBlockContainer(text)
{
    return `<div class="container alert alert-warning" role="alert">
                ${text}
            </div>`
}